export default "__VITE_ASSET__DVBIffkJ__$_?url__"